<template>
  <div>
    <input
      :type="input.show ? 'text' : 'password'"
      :class="'form-control ' + input.class"
      :value="value"
      @input="(e) => handleChange(e)"
      :placeholder="input.placeholder"
      :required="!input.optional"
      :disabled="input.disabled"
      :name="input.name"
    />
  </div>
</template>
<script>
export default {
  name: "InputPassword",
  components: {},
  props: {
    input: Object,
  },
  data: function() {
    return {};
  },
  methods: {
    handleChange(e) {
      this.$emit("handleChange", e);
    },
  },
};
</script>
